// extracted by mini-css-extract-plugin
export default {"content":"menuContainer_content__Pqucw"};